import { CampaignLanguage } from "@models/CampaignLanguage";

export class LocalizationData {

    language: CampaignLanguage;
    pairs: LocalizationPair[];
    alt_texts: Record<string, string> = {};

    constructor(language = null, languageObject: { [key: string]: any } = {}, pairs?: LocalizationPair[]) {
        this.language = language;

        if (languageObject.alt_texts) {
            this.alt_texts = languageObject.alt_texts;
        }

        this.pairs = Object.keys(languageObject)
            .filter((key) => key !== "alt_texts")
            .map((key) => new LocalizationPair(key, languageObject[key]));

        if (pairs) {
            this.pairs = pairs;
        }
    }

    toLanguageDocument() {
        const jsonDocument: { [key: string]: any } = {};
        this.pairs.forEach((pair: LocalizationPair) => jsonDocument[pair.key] = pair.value);

        if (this.alt_texts && Object.keys(this.alt_texts).length > 0) {
            jsonDocument.alt_texts = this.alt_texts;
        }

        return jsonDocument;
    }

}

export class LocalizationPair {

    key: string;
    value: string;

    constructor(key = "", value = "") {
        this.key = key;
        this.value = value;
    }

}
